<template>
  <div/>
</template>

<script>
  import customEdge from "./customEdge";
  import customNode from "./customNode";

  export default {
    name: "Base",
    data() {
      return {
        page: null
      }
    },
    created() {
      this.init()
    },
    methods:{
      init(){
        customNode.init()
        customEdge.init()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flow/components/Base/index.vue